export { AREA_LABEL } from '../briefe/labels';

export const requestPath = (clientId: string, id: string) => `/kanzlei/mandanten/${clientId}/anfragen?anfrage=${id}`;
